import Pedido from './componentes/Pedido.vue';
import PedidoLista from './componentes/PedidoLista.vue';
import PedidoRelatorio from './componentes/PedidoRelatorio.vue';
import PedidoRecebimento from './componentes/PedidoRecebimentoForm.vue'; 

export default {
  path: '/pedido',
  component: Pedido,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: PedidoLista,
      name: 'pedido',
    },
    {
      path: ':id/relatorio',
      component: PedidoRelatorio,
      name: 'pedido.relatorio'
    },
    {
        path: ':idCript/recebimento',
        component: PedidoRecebimento,
        name: 'pedido.recebimento'
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/pedido/rotas.js